<p class="row-label" [ngClass]="labelBoldClass" [innerHTML]="labelText"></p>

<div class="row-values-container" [attr.evidence-id]="evidenceIdName">
  @for (value of valueText; track value) {
    @if (!modal) {
      <div class="row-value c11n-text-md-bold" [innerHTML]="value"></div>
    }
    @if (modal) {
      <div class="row-value c11n-text-md-bold">
        <p>{{value}}</p>
        <button c11n-link id={{modal}} variant="primary-independent" (click)="modalClicked(modal)">Learn more</button>
      </div>
    }
  }
</div>
